"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Encrypted = void 0;
var neverthrow_1 = require("neverthrow");
exports.Encrypted = {
    getSlugs: function (params) {
        var slugs = ['_hash'];
        var dependencies = [];
        return (0, neverthrow_1.ok)({ slugs: slugs, dependencies: dependencies });
    },
    compute: function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var parentKey, token, original, _a, keyId, value, _b, success, text, e_1, json, hash;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        parentKey = params.targetField.replace('_hash', '');
                        if (!params.newInfoKeys[parentKey])
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        return [4 /*yield*/, params.aidkitCrypto];
                    case 1:
                        token = _d.sent();
                        if (!params.conn || !token)
                            return [2 /*return*/, (0, neverthrow_1.ok)({})];
                        original = token.decode(params.newInfoKeys[parentKey]);
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        _a = JSON.parse(Buffer.from(original, 'base64').toString('utf-8')), keyId = _a.keyId, value = _a.value;
                        return [4 /*yield*/, token.decrypt(keyId, value)];
                    case 3:
                        _b = _d.sent(), success = _b.success, text = _b.text;
                        if (success) {
                            original = text;
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _d.sent();
                        return [3 /*break*/, 5];
                    case 5:
                        // deals with the case where the original 
                        // is not compliant with the expected format
                        try {
                            json = JSON.parse(original);
                            if (!('userdata' in json)) {
                                original = JSON.stringify({ userdata: json });
                            }
                        }
                        catch (e) {
                            // assuming the original is a primitive (e.g. string, number, boolean)
                            original = JSON.stringify({ userdata: original });
                        }
                        hash = token.hash(original);
                        return [2 /*return*/, (0, neverthrow_1.ok)((_c = {},
                                _c[parentKey] = token.encode(original),
                                _c[parentKey + "_hash"] = hash,
                                _c))];
                }
            });
        });
    }
};
